import React from "react"
import CompaniesContext from "./context"
import { useGetCompanies } from "./hooks/use-get-companies"

interface ICompaniesProviderProps {
  children?: React.ReactNode
}

export const CompaniesProvider = (
  props: ICompaniesProviderProps
): JSX.Element => {
  const { companies, companiesMap, isLoading } = useGetCompanies()

  return (
    <CompaniesContext.Provider
      value={{
        companies,
        companiesMap,
        isLoading
      }}
    >
      {props.children}
    </CompaniesContext.Provider>
  )
}
